import SearchableSelect from '@/components/common/SearchableSelect';
import { CURRENCIES, formatCurrencyDisplay } from '@/lib/currencies';

interface CurrencySelectProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  testId?: string;
}

export function CurrencySelect({ value, onValueChange, placeholder = 'Select currency', className, testId }: CurrencySelectProps) {
  return (
    <SearchableSelect
      value={value}
      onChange={onValueChange}
      placeholder={placeholder}
      searchPlaceholder="Search currencies…"
      className={className}
      testId={testId}
      options={CURRENCIES.map((currency) => ({
        value: currency.code,
        label: formatCurrencyDisplay(currency),
        keywords: currency.code,
      }))}
    />
  );
}
